import { Href } from 'redux-little-router';

import { ValidationErrorData } from './common';
import { CampaignType } from './domain';
import { GdGoalType, GdRetargetingConditionRuleType } from './graphql-grid';
import { GroupId } from './groups';

export interface RetargetingConditionCampaignData {
    id: string;
    name: string;
    url: Href;
}

export interface RetargetingConditionGoal {
    id: string;
    domain?: string;
    name: string;
    type: GdGoalType;
    disabled?: boolean;
    counter?: string;
    audienceTypeName?: string;
}

export enum RetargetingConditionRuleType {
    METRIKA_GOAL_RULE = 'METRIKA_GOAL_RULE',
    METRIKA_SEGMENT_RULE = 'METRIKA_SEGMENT_RULE',
    AUDIENCE_SEGMENT_RULE = 'AUDIENCE_SEGMENT_RULE'
}

export interface RetargetingConditionDataRule {
    type: RetargetingConditionRuleType;
    id?: string;
    period?: number;
}

export type RetargetingConditionEditorDataRuleErrorKeys = 'period' | 'id';

export type RetargetingConditionEditorDataRuleErrors = {
    [key in RetargetingConditionEditorDataRuleErrorKeys]?: ValidationErrorData[];
};

export type RetargetingConditionEditorDataRule = RetargetingConditionDataRule & {
    isPeriodPristine: boolean;
    isIdPristine: boolean;
    errors: RetargetingConditionEditorDataRuleErrors;
};

export interface RetargetingConditionDataRulesGroup {
    type: GdRetargetingConditionRuleType;
    items: Array<RetargetingConditionEditorDataRule>;
}

export type RetargetingConditionId = string;

export interface RetargetingConditionData {
    id: RetargetingConditionId;
    name: string;
    description?: string;
    domains?: Array<string>;
    campaigns?: Array<RetargetingConditionCampaignData>;
    // В условии есть НЕ доступные цели
    hasUnavailableGoals: boolean;
    // Доступные только для корректировок ставок
    isForRatesAdjustment: boolean;
    // Необходимо для прогнозатора, что б избежать дополнительного запроса на бек
    goals?: Record<string, RetargetingConditionGoal>;
    hasGeoSegment: boolean;
    rulesGroups: Array<RetargetingConditionDataRulesGroup>;
}

export interface RetargetingConditionEditorItemData extends RetargetingConditionData {
    isSelected: boolean;
    isDeleting: boolean;
}

export interface RetargetingConditionAudienceEditorState extends RetargetingConditionData {
    isDeleting: boolean;
}

export interface RetargetingEditorState {
    isVisible: boolean;
    conditions: Array<RetargetingConditionEditorItemData>;
    conditionIdToScrollTo?: RetargetingConditionId;
}

export type RetargetingAudienceEditorState = Record<GroupId, RetargetingConditionAudienceEditorState>;

export interface RetargetingConditionEditorState {
    groupId: GroupId;
    constants: {
        maxNameLength: number;
        maxDescriptionName: number;
        // максимальное количество наборов правил в условии ретаргетинга
        maxRetargetingConditionRulesGroups: number;
        // максимальное количество правил в наборе условия ретаргетинга
        maxRetargetingConditionRulesInGroup: number;
        // максимальный период цели
        rulePeriodMaxValue: number;
    };
    isVisible: boolean;
    isNew: boolean;
    conditionData: RetargetingConditionData;
    goals: Array<RetargetingConditionGoal>;
    isDataLoading: boolean;
    isSaving: boolean;
    isSavingAsNewCondition: boolean;
    isSavingAsNewConditionDisabled: boolean;
    enableVisitorsForecast: boolean;
    visitorsForecast?: number;
    errors: RetargetingEditorErrors;
    wasChanged: boolean;
    isNamePristine: boolean;
    wasSaved: boolean;
    campaignType?: CampaignType;
}

export type RetargetingConditionEditorErrorKeys =
    | 'visitorsForecast'
    | 'general'
    | 'name'
    | 'description'
    | 'serverGlobal'
    | 'dataLoading'
    | 'goalsOrSegment';

export type RetargetingEditorErrors = { [key in RetargetingConditionEditorErrorKeys]?: ValidationErrorData[] };
